import * as wms from './WMS';
// import * as csw from './CSW';
// import * as wmts from './WMTS';
// import * as tms from './TMS';
// import * as wfs from './WFS';

export default {
    // TODO: we should separate catalog specific API from OGC services API, to define better the real interfaces of each API.
    // TODO: validate could be converted in a simple function
    // TODO: testService could be converted in a simple Promise
    // 'csw': csw,
    // 'wfs': wfs,
    'wms': wms,
    // 'tms': tms,
    // 'wmts': wmts,
    // 'backgrounds': backgrounds,
    // '3dtiles': threeDTiles
};